function CanvasResize() {
    const canvasPlaceholder = document.getElementById("canvas-placeholder");
    const bgElement = document.getElementById("bg");
    const scrollThreshold = 600;

    Resize();

    function GetNewSizeInPX() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;

        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        const limitedWindowWidth = windowWidth / 2;
        const limitedWindowHeight = limitedWindowWidth;

        const initialWidth = limitedWindowWidth;
        const finalWidth = 100; // in px
        const initialHeight = limitedWindowHeight;
        const finalHeight = 100; // in px

        const width = initialWidth - (initialWidth - finalWidth) * (scrollPosition / scrollThreshold);
        const height = initialHeight - (initialHeight - finalHeight) * (scrollPosition / scrollThreshold);

        return {
            x: width * 0.8,
            y: height * 0.8,
        };
    }

    function Resize() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop;

        if (scrollPosition < scrollThreshold) {
            const newSize = GetNewSizeInPX();
            const width = newSize.x;
            const height = newSize.y;

            const percentage = (1 - (scrollPosition / scrollThreshold)) * 50;
            const padding = (1 - (scrollPosition / scrollThreshold)) * 40;

            if (width < 768) bgElement.style.left = `-30px`;
            if (width < 300) bgElement.style.left = `-15px`;

            bgElement.style.width = `${width}px`;
            bgElement.style.height = `${height}px`;
            bgElement.style.top = `calc(${percentage}% - ${parseFloat(bgElement.style.height) / 2}px)`;
            
            canvasPlaceholder.style.top = `calc(${percentage}% - ${parseFloat(bgElement.style.height) / 2}px)`;
            canvasPlaceholder.style.width = `${width}px`;
            canvasPlaceholder.style.height = `${height}px`;
        } else {
            bgElement.style.width = `100px`;
            bgElement.style.height = `100px`;
            bgElement.style.top = `0`;
            bgElement.style.left = `0`;

            bgElement.style.top = `100px`;
            canvasPlaceholder.style.width = `100px`;
            canvasPlaceholder.style.height = `100px`;
        }
    }

    window.addEventListener('resize', Resize);
    window.addEventListener('scroll', Resize);
}

export default CanvasResize;